import React, { useState } from "react";
import Icon from "../Icon/Icon";
import Folder from "../Folder/Folder";

const MainBody = () => {
    const [show, setShow] = useState(0)

    return(
        <div id="main">
            <div className="screen">
                <div className="icons">
                    <Icon name={"About me"} id={1} show={setShow}/>
                    <Icon name={"Projects"} id={2} show={setShow}/>
                    <Icon name={"Skills"} id={3} show={setShow}/>
                </div>
                {
                    show != 0 && <Folder show={show} close={setShow}></Folder>
                }
            </div>
        </div>
    )
}

export default MainBody